import isObject from "./isObject.ts";

/**
 * Checks if an element is a `WeakMap`.
 *
 * @param obj the target object
 * @returns the query result
 */
const isWeakMap = (obj?: unknown): obj is WeakMap<WeakKey, unknown> =>
  (isObject(obj) && obj.constructor.name === "WeakMap") || false;
export default isWeakMap;
